module.exports = __webpack_public_path__ + "static/img/pitch_blue_old.1795d00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_blue_old.png
// module id = yvzL
// module chunks = 94